import { useParams, Link } from "react-router-dom";
import React from "react";
import { FaReact, FaNodeJs, FaDatabase, FaAws, FaHtml5, FaCss3Alt, FaJs } from "react-icons/fa";
import { Container, Row, Col, Button , Card} from "react-bootstrap";
import products from "../data/products";
import Footer from "../Footer";
import Navbar from "../Navbar";
import Ai from "../assets/ai.mp4";
import Develop from "../assets/develop.mp4";
import process1 from "../assets/7814530.jpg";
import process2 from "../assets/9594694.jpg";
import process3 from "../assets/19199697.jpg";
import Faq from "../Faq";
const ProductDetail = () => {
  const { id } = useParams();
  const product = products.find((p) => p.id === parseInt(id));
  const processes = [
    {
      title: "Research & Planning",
      desc: "We start by understanding your business needs, analyzing market trends, and creating a clear roadmap.",
      img: process1
    },
    {
      title: "Design & Development",
      desc: "Our team designs intuitive UI/UX and develops scalable, secure, and modern applications tailored to your needs.",
      img: process2
    },
    {
      title: "Testing & Delivery",
      desc: "We ensure quality through rigorous testing before delivering a reliable, high-performance product.",
      img: process3
    }
  ];


 const technologies = [
    { name: "React", icon: <FaReact className="text-cyan-400 text-5xl" /> },
    { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-5xl" /> },
    { name: "JavaScript", icon: <FaJs className="text-yellow-400 text-5xl" /> },
    { name: "HTML5", icon: <FaHtml5 className="text-orange-500 text-5xl" /> },
    { name: "CSS3", icon: <FaCss3Alt className="text-blue-400 text-5xl" /> },
    { name: "Database", icon: <FaDatabase className="text-purple-400 text-5xl" /> },
    { name: "AWS", icon: <FaAws className="text-yellow-500 text-5xl" /> },
  ];
  if (!product) {
    return (
        <>
       
      <Container className="py-5 text-center text-white">
        <h2>Product not found</h2>
        <Link to="/">
          <Button variant="secondary" className="mt-3">Back to Home</Button>
        </Link>
      </Container>
      </>
    );
  }

  return (
    <>
     <section
      style={{
        position: "relative",
        height: "100vh",
        width: "100%",
        overflow: "hidden",
      }}
    >
        <Navbar />
      {/* Fullscreen Video */}
      <video
        src={product.video}
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
          objectFit: "cover",
          zIndex: 1,
        }}
      />

      {/* Dark Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          zIndex: 2,
        }}
      />

      {/* Content */}
      <Container
        className="d-flex flex-column justify-content-center align-items-center text-center text-white"
        style={{ height: "100%", zIndex: 3, position: "relative" }}
      >
        <h1 className="fw-bold mb-3">{product.title}</h1>
        <p style={{ fontSize: "1.2rem", maxWidth: "800px", lineHeight: "1.6" }}>
          {product.text}
        </p>
        {product.description && (
          <p className="mt-3" style={{ maxWidth: "700px" }}>
            {product.description}
          </p>
        )}
       
      </Container>
    </section>
      <section
      className="text-white py-5"
      style={{ backgroundColor: "#121212" }} // off-black background
    >
       <br />
        <br />
         <br />
          <br />
      <Container>
        {/* Section Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold display-5">🚀 Know Our Approach</h2>
           
          <p className="lead text-secondary">
            We follow a structured process to ensure innovation, efficiency, and quality delivery.
          </p>
        </div>
         <br />
          <br />

        {/* 3 Process Cards */}
        <Row className="g-4">
          {processes.map((process, index) => (
            <Col md={4} key={index}>
              <Card
                className="h-100 border-0 text-white overflow-hidden rounded-4 shadow"
                style={{
                  backgroundColor: "#1C1C1C",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.8)"
                }}
              >
                {/* Image with Number Badge */}
                <div className="position-relative">
                  <Card.Img
                    variant="top"
                    src={process.img}
                    alt={process.title}
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <div
                    className="position-absolute top-0 start-0 m-3 d-flex align-items-center justify-content-center fw-bold"
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #8A2BE2, #d6299c)",
                      color: "#fff",
                      fontSize: "1.2rem",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.6)"
                    }}
                  >
                    {index + 1}
                  </div>
                </div>

                {/* Card Content */}
                <Card.Body className="p-4">
                  <Card.Title className="fw-bold">{process.title}</Card.Title>
                  <Card.Text className="text-light">{process.desc}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
       <br />
        <br />
         <br />
          <br />
    </section>
   

  <section
  className="text-white py-5"
  style={{
    backgroundColor: "#d6299cff"
  }}
>
      <br />
      <Container>
        {/* Heading and Paragraph Row */}
        <Row className="align-items-center mb-5">
          <Col md={6}>
            <h2 className="display-4 fw-bold"  
         
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontSize: "2.8rem",
            letterSpacing: "0.5px",
            lineHeight: "1.3",
            textTransform: "uppercase",
            color: "#fff",
          }}
        >
          
              Technology <br /> We Use
            </h2>
          </Col>
          <Col md={6}>
            <p className="text-light lead">
              We use cutting-edge technologies to build fast, scalable, and secure
              applications. From modern frontend frameworks to robust backend
              systems and cloud solutions, our stack ensures high performance.
            </p>
          </Col>
        </Row>

        {/* Horizontal Card */}
        <Card className="bg-dark text-center p-4 text-light border-0 rounded-4 shadow">
          <br />
          <Row className="g-6 justify-content-center">
            {technologies.map((tech, index) => (
              <Col key={index} xs={6} sm={3} md={4} lg={2}>
                <div className="d-flex flex-column align-items-center">
           <div
  className="d-flex align-items-center justify-content-center rounded-circle  mb-3"
  style={{ width: "100px", height: "100px" , background: "#3B3B3B", boxShadow: "0 4px 15px rgba(0, 0, 0, 0.8)",}}
>
  {React.cloneElement(tech.icon, { className: "display-3 text-pink", style: { color: "#d6299cff" } })}
</div>

                  <span className="fw-medium">{tech.name}</span>
                </div>
              </Col>
            ))}
           
          </Row>
           <br />
            <br />
        </Card>
      </Container>
    <br />
    <br />
    <br />
    </section>
     <section className="text-white py-5" style={{ backgroundColor: "#1C1C1C" }}>
        <br />
      <br />
      <br />
      <Container>
        <Row className="align-items-center g-4">
          {/* First Column - Heading + Subheading */}
          <Col md={4}>
            <h2 className="display-5 fw-bold text-light mb-3">
              Featured  <br /> Case Studies
            </h2>
            <p className="lead text-light">
              We leverage modern technologies to build fast, scalable, and secure applications.
            </p>
          </Col>

          {/* Second Column - Video Card 1 */}
          <Col md={4}>
            <Card
              className="text-center border-0 rounded-4 shadow overflow-hidden"
              style={{ backgroundColor: "#1C1C1C", boxShadow: "0 6px 15px rgba(0,0,0,0.8)" }}
            >
              <video
                src={Ai}
                autoPlay
                loop
                muted
                playsInline
                className="w-100"
                style={{ height: "250px", objectFit: "cover" }}
              />
              <Card.Body>
                <h5 className="fw-bold text-light">AI Development</h5>
                <p className="text-light small">Building smarter applications with AI</p>
              </Card.Body>
            </Card>
          </Col>

          {/* Third Column - Video Card 2 */}
          <Col md={4}>
            <Card
              className="text-center border-0 rounded-4 shadow overflow-hidden"
              style={{ backgroundColor: "#1C1C1C", boxShadow: "0 6px 15px rgba(0,0,0,0.8)" }}
            >
              <video
                src={Develop}
                autoPlay
                loop
                muted
                playsInline
                className="w-100"
                style={{ height: "250px", objectFit: "cover" }}
              />
              <Card.Body>
                <h5 className="fw-bold text-light">App Development</h5>
                <p className="text-light small">Modern solutions for web & mobile</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <br />
      <br />
      <br />
    </section>
    <Faq />
    <Footer />
    </>
  );
};

export default ProductDetail;
